import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ isDarkMode, toggleDarkMode, className = '', theme }) => {
  return (
    <button 
      onClick={toggleDarkMode} 
      className={`p-2 rounded-full transition-colors ${theme?.textMuted || ''} hover:${theme?.text || ''} ${className}`}
    >
      {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};

export default ThemeToggle;